import { nonNegativeMoneySchema } from '@/common/utils/zod';
import { z } from 'zod';

export const taxProfileFormSchema = z.object({
  maritalStatus: z.enum(['not_married', 'married_singular', 'married_joint']),
  dependents: z.coerce
    .number({
      invalid_type_error: 'errors.input.invalid_number',
    })
    .nonnegative('errors.input.not_negative'),
  salary: nonNegativeMoneySchema,
});

export type TTaxProfileFormSchema = z.infer<typeof taxProfileFormSchema>;
